<div class="container d-flex align-items-center justify-content-between rtl">
    <i id="mobileNav" class="bi bi-list mobile-nav-toggle ml-4" (click)="onMobileNavToggle()"></i>

    <div class="logo">
        <a href="index.html"><img src="assets/img/drme-logo-text32.png" alt="" class="img-fluid"></a>
    </div>

    <nav id="navbar" class="navbar rtl iran-sans font-13 fill w-100 pr-4" #navBar>
        <ul>
            <li><a class="nav-link scrollto" href="#hero">صفحه اصلی</a></li>
            <li><a class="nav-link scrollto" href="#services">خدمات</a></li>
            <li class="dropdown"><a href="#"><span>اطلاعات سلامت</span> <i class="bi bi-chevron-down"></i></a>
                <ul>
                    <li><a [routerLink]="['/drme-blog']">بیماری ها و شرایط</a></li>
                    <li><a href="#">علائم و نشانه ها</a></li>
                    <li><a href="#">اقدامات تشخیصی</a></li>
                    <li><a href="#">اقدامات درمانی</a></li>
                </ul>
            </li>
            <li><a class="nav-link scrollto" href="#about">بیماران مثل من</a></li>
            <li><a class="nav-link scrollto" href="#about">درباره ما</a></li>
            <div class="fill"></div>
            <li><a class="imdoctor" href="http://ep.drme.ir">پزشک هستم</a></li>
            <li><a class="getstarted" href="http://apt.drme.ir?login=true">ورود / عضویت</a></li>
        </ul>
    </nav><!-- .navbar -->

</div>